import request from "@/utils/request";

function getPoiList(data) {  //获取景点列表
    return request({
        url: "/touristFlowTrend/getPoiList",
        method: "POST",
        data
    })
}

function touristsDistributionGetVisitDistribution(data) {   //到访分布热力图
    return request({
        url: "/touristsDistribution/getVisitDistribution",
        method: "POST",
        data
    })
}

function touristsDistributionGetSourceRate(data){       //来源地排名
    return request({
        url: "/touristsDistribution/getSourceRate",
        method: "POST",
        data
    })
}

function touristsDistributionGetSourceHeatMap(data){      //获取来源热力图
    return request({
        url: "/touristsDistribution/getSourceHeatMap",
        method: "POST",
        data
    })
}

function touristsDistributionGetSourcePoiRank(data){   //获取来源地POI排行
    return request({
        url: "/touristsDistribution/getSourcePoiRank",
        method: "POST",
        data
    })
}

function touristsDistributionGetTouristFlowDayHeat(data){    // 获取日承载量
    return request({
        url: "/touristsDistribution/getTouristFlowDayHeat",
        method: "POST",
        data
    })
}

export {
    getPoiList,
    touristsDistributionGetVisitDistribution,
    touristsDistributionGetSourceRate,
    touristsDistributionGetSourceHeatMap,
    touristsDistributionGetSourcePoiRank,
    touristsDistributionGetTouristFlowDayHeat
}
